import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DbChatState {
  loading: boolean;
  error: string | null;
}

const initialState: DbChatState = {
  loading: false,
  error: null,
};

const dbChatSlice = createSlice({
  name: "dbChat",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { setLoading, setError, clearError } = dbChatSlice.actions;
export default dbChatSlice.reducer;

// Selectors
export const selectDbChatLoading = (state: { dbChat: DbChatState }) =>
  state.dbChat?.loading ?? false;
export const selectDbChatError = (state: { dbChat: DbChatState }) =>
  state.dbChat?.error ?? null;
